var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var _a, _b, _c;
/* eslint-disable max-lines */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { UNAVAILABLE_IMAGE_URL } from '../constants/general';
import { getOrderActionEligibility } from '../components/order-details/util/FulfillmentStatus';
import { setTrackingButtonVisibility } from '../components/order-details/util/TrackingLogics';
import { instoreOrderNumberFormat } from '../components/shared/order-number-formatter/OrderNumberFormatter';
import { getCookieValue } from './cookie-helper';
import { convertToYYYYMMDD } from './date-utils';
import { isProductTypeEPPOnly } from './hdppCheck-utils';
import { getDisplayHeader } from './order-details/OrderDetailsUtils';
import { statusStepperData } from './order-history/card-utils';
import { getSvocId } from './user';
export var isSsr = typeof window === 'undefined';
// Checks if the current environment is not SSR.
export var getWindow = function () {
    if (typeof window !== 'undefined') {
        return window;
    }
    return undefined;
};
export var getDocument = function () {
    if (typeof document !== 'undefined') {
        return document;
    }
    return undefined;
};
export var getHost = function () {
    var _a;
    if (isSsr)
        return '';
    if (process.env.NODE_ENV === 'production' && !process.env.DOMAIN_NAME) {
        return "https://".concat((_a = getWindow()) === null || _a === void 0 ? void 0 : _a.location.hostname);
    }
    return window.location.origin;
};
var isMobile = /Android|webOS|iPhone|iPad|iPod|Windows Phone|BlackBerry|IEMobile|Opera Mini/i.test((_c = (_b = (_a = getWindow()) === null || _a === void 0 ? void 0 : _a.navigator) === null || _b === void 0 ? void 0 : _b.userAgent) !== null && _c !== void 0 ? _c : '');
/**
 * Checks if the current environment is an LLC (Limited Liability Company) environment.
 * In this context, LLC refers to specific QA environments identified by their hostnames.
 * Returns true if the current hostname includes 'hd-qa71' or 'hd-qa74'.
 * Use this function to enable or disable features specific to these LLC environments.
 */
export var isLLC = function () {
    var _a, _b, _c, _d, _e, _f;
    if (((_c = (_b = (_a = getWindow()) === null || _a === void 0 ? void 0 : _a.location) === null || _b === void 0 ? void 0 : _b.host) === null || _c === void 0 ? void 0 : _c.includes('hd-qa71')) ||
        ((_f = (_e = (_d = getWindow()) === null || _d === void 0 ? void 0 : _d.location) === null || _e === void 0 ? void 0 : _e.host) === null || _f === void 0 ? void 0 : _f.includes('hd-qa74'))) {
        return true;
    }
    return false;
};
export var getChannelID = function () { return (isMobile ? 2 : 1); };
export var generateXB3TraceID = function () {
    return Math.random().toString(16).substring(2) +
        new Date().getTime().toString(16).substring(0, 15);
};
/**
 * Gets number of pages for pagiantion components
 */
export var getNumPages = function (pageLimit, recordsCount) {
    return Math.ceil(recordsCount / pageLimit) || 1;
};
/**
 * Format basic US phone number format.
 */
export var formatPhoneNumber = function (phoneNumber) {
    if (phoneNumber.length === 10) {
        return "".concat(phoneNumber.slice(0, 3), "-").concat(phoneNumber.slice(3, 6), "-").concat(phoneNumber.slice(6));
    }
    if (phoneNumber.length === 11) {
        return "".concat(phoneNumber.slice(0, 1), "-").concat(phoneNumber.slice(1, 4), "-").concat(phoneNumber.slice(4, 7), "-").concat(phoneNumber.slice(7));
    }
    return phoneNumber;
};
/**
 *
 */
export var floorNumberWithCommas = function (num, decimalPostion) {
    if (num === 0) {
        return '0';
    }
    if (!num || Number.isNaN(num)) {
        return '';
    }
    return Math.floor(Number(num))
        .toFixed(decimalPostion)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};
/**
 *
 * @param customStartDate
 * @param customEndDate
 * @returns
 */
/**
 * Util used for DateSelectionDropdown.tsx
 */
export var dateSelectionCustomText = function (customStartDate, customEndDate) {
    if (customStartDate && customEndDate) {
        var customStartDateTime = new Date(customStartDate);
        var start = convertToYYYYMMDD(customStartDateTime);
        var customEndDateTime = new Date(customEndDate);
        var end = convertToYYYYMMDD(customEndDateTime);
        return "".concat(start, " - ").concat(end);
    }
    return 'Custom Date Range';
};
export var getTmxId = function () {
    var _a, _b, _c, _d, _e;
    var nativeTMXID = '';
    if ((_b = (_a = getWindow()) === null || _a === void 0 ? void 0 : _a.__EXPERIENCE_CONTEXT__) === null || _b === void 0 ? void 0 : _b.isConsumerApp) {
        nativeTMXID = getUrlParam('guid');
    }
    return (nativeTMXID || ((_e = (_d = (_c = getWindow()) === null || _c === void 0 ? void 0 : _c.THD_ACCOUNT_LIB) === null || _d === void 0 ? void 0 : _d.TMX) === null || _e === void 0 ? void 0 : _e.getTMXsessionId()) || '');
};
export var getUrlParam = function (key) {
    var _a;
    var searchParams = typeof window !== 'undefined' ? (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.search : '';
    var urlParams = new URLSearchParams(searchParams);
    return urlParams.get(key);
};
/**
 * Functions used for userState, policy, trails and enrollment
 * set for left nav within server.js
 */
export var transformToTrialsObj = function (_a) {
    var _b;
    var data = _a.data;
    var trials = {};
    (_b = data === null || data === void 0 ? void 0 : data.features) === null || _b === void 0 ? void 0 : _b.forEach(function (feature) {
        trials[feature] = true;
    });
    return trials;
};
export var filterOutPII = function (_a) {
    var data = _a.data;
    var firstName = data.firstName, lastName = data.lastName, phoneNumber = data.phoneNumber, email = data.email, userAddress = data.userAddress, customer = data.customer, needed = __rest(data, ["firstName", "lastName", "phoneNumber", "email", "userAddress", "customer"]);
    var customerPhone = customer.phoneNumber, accountName = customer.accountName, neededFromCustomer = __rest(customer, ["phoneNumber", "accountName"]);
    return __assign(__assign({}, needed), { customer: __assign({}, neededFromCustomer) });
};
var constructOrderNumberFn = function (orderOrigin, orderNumbers, orderNumber, registerNumber, transactionId, receiptDetails, localDelivery) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    if (orderOrigin !== 'online' && orderOrigin !== 'Online') {
        // Checks if order is "H" order
        // Added a check for "W" orders, since online orders were appearing as in-store orders in the line items.
        if (['H', 'W', 'C'].includes((_b = (_a = orderNumbers === null || orderNumbers === void 0 ? void 0 : orderNumbers[0]) === null || _a === void 0 ? void 0 : _a[0]) !== null && _b !== void 0 ? _b : '') ||
            ['H', 'W', 'C'].includes((_c = orderNumber === null || orderNumber === void 0 ? void 0 : orderNumber[0]) !== null && _c !== void 0 ? _c : '')) {
            return (_e = (_d = orderNumbers === null || orderNumbers === void 0 ? void 0 : orderNumbers[0]) !== null && _d !== void 0 ? _d : orderNumber) !== null && _e !== void 0 ? _e : '';
        }
        return instoreOrderNumberFormat(registerNumber, transactionId);
    }
    return (_h = (_g = (_f = orderNumbers === null || orderNumbers === void 0 ? void 0 : orderNumbers[0]) !== null && _f !== void 0 ? _f : orderNumber) !== null && _g !== void 0 ? _g : receiptDetails) !== null && _h !== void 0 ? _h : '';
};
export var routeBuilder = function (_a) {
    var index = _a.index, orderNumber = _a.orderNumber, orderNumbers = _a.orderNumbers, orderOrigin = _a.orderOrigin, receiptDetails = _a.receiptDetails, registerNumber = _a.registerNumber, salesDate = _a.salesDate, storeNumber = _a.storeNumber, transactionId = _a.transactionId, transactionIdWithCheckDigit = _a.transactionIdWithCheckDigit, transactionType = _a.transactionType, nickName = _a.nickName, deliveryDate = _a.deliveryDate, workorderExceptions = _a.workorderExceptions, POJobName = _a.POJobName, projectName = _a.projectName, status = _a.status, localDelivery = _a.localDelivery;
    var formattedOrderOrigin = orderOrigin === null || orderOrigin === void 0 ? void 0 : orderOrigin.replace('#', '%23');
    var nonHOrder = orderNumbers === null || orderNumbers === void 0 ? void 0 : orderNumbers.find(function (order) { return (order === null || order === void 0 ? void 0 : order[0]) !== 'H'; });
    var constructOrderNumber = constructOrderNumberFn(orderOrigin, orderNumbers, orderNumber, registerNumber, transactionIdWithCheckDigit !== null && transactionIdWithCheckDigit !== void 0 ? transactionIdWithCheckDigit : transactionId, receiptDetails, localDelivery);
    var transactionTypeModifier = function (type) {
        if (type === 'Return')
            return 'R';
        if (type === 'Sale')
            return 'S';
        return type;
    };
    return "?orderNumber=".concat((orderNumbers !== null && orderNumbers !== void 0 ? orderNumbers : []).length > 1 ? nonHOrder : constructOrderNumber).concat(salesDate ? '&salesDate=' + salesDate : '').concat(storeNumber ? '&storeNumber=' + storeNumber : '').concat(transactionId ? '&transactionId=' + transactionId : '').concat(registerNumber ? '&registerNumber=' + registerNumber : '').concat(transactionType
        ? '&transactionType=' + transactionTypeModifier(transactionType)
        : '').concat(deliveryDate ? '&deliveryDate=' + deliveryDate : '').concat(POJobName ? '&POJobName=' + encodeURIComponent(POJobName.trim()) : '').concat(projectName ? '&projectName=' + projectName : '').concat(status ? '&status=' + status : '').concat(workorderExceptions ? '&workorderExceptions=' + workorderExceptions : '').concat(formattedOrderOrigin
        ? '&orderOrigin=' + encodeURIComponent(formattedOrderOrigin.trim())
        : '').concat(nickName ? '&nickName=' + nickName : '').concat(index !== null && index !== undefined ? '&index=' + index : '').concat(localDelivery ? '&localDelivery=' + localDelivery : '');
};
export var checkForMultipleStatuses = function (fulfillmentGroup, index, fulfillmentItem) {
    var totalCount = [];
    fulfillmentGroup.forEach(function (item) {
        var _a;
        if (statusStepperData(null, 'title', item === null || item === void 0 ? void 0 : item.fulfillmentType) ===
            statusStepperData(null, 'title', (_a = fulfillmentGroup === null || fulfillmentGroup === void 0 ? void 0 : fulfillmentGroup[index]) === null || _a === void 0 ? void 0 : _a.fulfillmentType)) {
            totalCount.push(item);
        }
    });
    if (totalCount.length > 1) {
        return "".concat(totalCount.findIndex(function (item) {
            var _a, _b, _c, _d, _e, _f;
            return ((_a = item === null || item === void 0 ? void 0 : item.lineItems) === null || _a === void 0 ? void 0 : _a.length) === ((_b = fulfillmentItem === null || fulfillmentItem === void 0 ? void 0 : fulfillmentItem.lineItems) === null || _b === void 0 ? void 0 : _b.length) &&
                ((_d = (_c = item === null || item === void 0 ? void 0 : item.lineItems) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.skuNumber) ===
                    ((_f = (_e = fulfillmentItem === null || fulfillmentItem === void 0 ? void 0 : fulfillmentItem.lineItems) === null || _e === void 0 ? void 0 : _e[0]) === null || _f === void 0 ? void 0 : _f.skuNumber);
        }) + 1, " of ").concat(totalCount.length);
    }
    return '';
};
export var checkHasGiftCard = function (fulfillmentGroup) {
    var _a, _b;
    return (((_a = fulfillmentGroup === null || fulfillmentGroup === void 0 ? void 0 : fulfillmentGroup.lineItems) === null || _a === void 0 ? void 0 : _a.length) ===
        ((_b = fulfillmentGroup === null || fulfillmentGroup === void 0 ? void 0 : fulfillmentGroup.lineItems) === null || _b === void 0 ? void 0 : _b.filter(function (item) { return item === null || item === void 0 ? void 0 : item.isGiftCard; }).length));
};
export var checkIsHDPPinAnyLineItem = function (fulfillmentGroup) {
    /*
      ProductTypeEPPOnly util function check if the lineItem has productType= 'EPP' or not which is HDPP lineItem.
      If any of the lineItem has HDPP order do not render DeliveryComponent at all to that LineItem
      isProductTypeEPPOnly()-->if return true --> has hdpp --> do not show delivery component
    */
    return isProductTypeEPPOnly((fulfillmentGroup === null || fulfillmentGroup === void 0 ? void 0 : fulfillmentGroup.lineItems) || []);
};
export var checkEligibleForTracking = function (fulfillmentGroup, orderDetailsData) {
    /* Corresponds with logic determining if Track Shipment is rendered in ActionButtons to determine if multiple shipments groups
    should be rendered for multiple shipments */
    var _a, _b, _c, _d;
    var statusCode = (_c = (_b = (_a = fulfillmentGroup === null || fulfillmentGroup === void 0 ? void 0 : fulfillmentGroup.lineItems) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.statusCode) !== null && _c !== void 0 ? _c : 0;
    var fulfillmentType = fulfillmentGroup === null || fulfillmentGroup === void 0 ? void 0 : fulfillmentGroup.fulfillmentType;
    var isTrackingEligibleForFulfillmentMethod = getOrderActionEligibility(fulfillmentType, statusCode).isTrackingEligibleForFulfillmentMethod;
    var isTrackingVisible = setTrackingButtonVisibility(statusCode, fulfillmentType, fulfillmentGroup);
    return (isTrackingVisible &&
        isTrackingEligibleForFulfillmentMethod &&
        ['Online', 'online'].includes((_d = orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.orderOrigin) !== null && _d !== void 0 ? _d : ''));
};
export var createMultipleStatusesAndShipments = function (fulfillmentGroups, enableReturnProgressDate) {
    var fulfillments = {};
    fulfillmentGroups.forEach(function (fulfillmentGroup) {
        var _a;
        var header = (_a = getDisplayHeader(fulfillmentGroup, enableReturnProgressDate)) !== null && _a !== void 0 ? _a : '';
        if (!fulfillments[header]) {
            fulfillments[header] = [1, 1];
        }
        else {
            fulfillments[header][1] += 1;
        }
    });
    return fulfillments;
};
export var checkForMultipleStatusesAndShipments = function (header, multipleStatusesAndShipments) {
    var _a, _b, _c, _d, _e;
    if (header === undefined)
        return '';
    if (multipleStatusesAndShipments[header][1] === 1) {
        return header;
    }
    if (((_a = multipleStatusesAndShipments[header]) === null || _a === void 0 ? void 0 : _a[0]) <=
        ((_b = multipleStatusesAndShipments[header]) === null || _b === void 0 ? void 0 : _b[1])) {
        var headerText = "".concat(header, " ").concat((_c = multipleStatusesAndShipments[header]) === null || _c === void 0 ? void 0 : _c[0], " of ").concat((_d = multipleStatusesAndShipments[header]) === null || _d === void 0 ? void 0 : _d[1]);
        // eslint-disable-next-line no-param-reassign
        multipleStatusesAndShipments[header][0] =
            ((_e = multipleStatusesAndShipments[header]) === null || _e === void 0 ? void 0 : _e[0]) + 1;
        return headerText;
    }
    return '';
};
export var generateImageUrl = function (lineItem) {
    var _a, _b;
    if (lineItem === null || lineItem === void 0 ? void 0 : lineItem.imageUrl) {
        return lineItem === null || lineItem === void 0 ? void 0 : lineItem.imageUrl;
    }
    if ((_a = lineItem === null || lineItem === void 0 ? void 0 : lineItem.giftCard) === null || _a === void 0 ? void 0 : _a.thdImageUrl) {
        return (_b = lineItem === null || lineItem === void 0 ? void 0 : lineItem.giftCard) === null || _b === void 0 ? void 0 : _b.thdImageUrl;
    }
    return UNAVAILABLE_IMAGE_URL;
};
// set of protected feature switches not allowed to be overwritten by a cookie
var PROTECTED_FS_SET = new Set(['allowSTHUndeliveredReturns']);
/**
 * Helper funciton used to determine if FS is turned on, FS can be overwritten via cookie
 * @param featureSwitchName FS Name
 * @returns true if FS is set to true or 1
 */
// Used when instance variable is not available in non-hooks
export var getFeatureSwitchValueStatic = function (featureSwitchName) {
    var _a, _b;
    if (featureSwitchName === void 0) { featureSwitchName = ''; }
    if (!getWindow())
        return 'false';
    var isProd = window.location.hostname === 'www.homedepot.com';
    var isFSProtected = isProd && PROTECTED_FS_SET.has(featureSwitchName);
    if (!isFSProtected) {
        // Check cookies first
        var cookieValue = getCookieValue(featureSwitchName);
        if (cookieValue !== undefined) {
            return cookieValue;
        }
    }
    var featureSwitchValue = (_b = (_a = window.__EXPERIENCE_PROPS__) === null || _a === void 0 ? void 0 : _a.expConfiguration) === null || _b === void 0 ? void 0 : _b[featureSwitchName];
    return featureSwitchValue;
};
export var getCookieByName = function (name) {
    var prefix = "".concat(name, "=");
    var begin = document.cookie.indexOf("; ".concat(prefix));
    var value = null;
    // cookie key/value pair is not the 2nd or further on.
    if (begin === -1) {
        begin = document.cookie.indexOf(prefix);
        if (begin !== 0) {
            return value;
        }
        var end_1 = document.cookie.indexOf(';', begin);
        value = decodeURI(document.cookie.substring(begin + prefix.length, end_1));
    }
    // the cookie key/value pair does exist.
    begin += 2;
    var end = document.cookie.indexOf(';', begin);
    // the end of the cookie does not exist?
    if (end === -1) {
        end = document.cookie.length;
    }
    value = decodeURI(document.cookie.substring(begin + prefix.length, end));
    return value;
};
/**
 * Get the value of a feature switch from experience
 */
export var getFeatureSwitchValue = function (fsName, isCookieOverwriteable) {
    var _a, _b;
    var selectedFs = (_b = (_a = getWindow()) === null || _a === void 0 ? void 0 : _a.__EXPERIENCE_PROPS__) === null || _b === void 0 ? void 0 : _b.expConfiguration[fsName];
    if (isCookieOverwriteable) {
        selectedFs = getFeatureSwitchValueStatic(fsName);
    }
    // Return false if the feature switch is not found
    if (selectedFs === undefined || selectedFs === null) {
        return null;
    }
    // Checks if the feature switch is a boolean then returns the value as a boolean
    if (selectedFs.toLocaleLowerCase() === 'true') {
        return true;
    }
    if (selectedFs.toLocaleLowerCase() === 'false') {
        return false;
    }
    // Checks if the feature switch is a number then returns the value as a number
    if (!Number.isNaN(Number(selectedFs))) {
        return Number(selectedFs);
    }
    // Returns the value as a string
    return selectedFs;
};
export var redirectToDownloadsPage = function (redirectedFrom) {
    setTimeout(function () {
        var _a, _b;
        (_a = getWindow()) === null || _a === void 0 ? void 0 : _a.sessionStorage.setItem(redirectedFrom, 'true');
        (_b = getWindow()) === null || _b === void 0 ? void 0 : _b.location.assign('/myaccount/downloads');
    }, 3000);
};
export var PHODPageData = function () {
    var _a, _b, _c, _d, _e, _f;
    var OPExpSessionData = (_a = getWindow()) === null || _a === void 0 ? void 0 : _a.sessionStorage.getItem('purchaseHistoryPage');
    var userId = getSvocId();
    var defaultSessionData = {
        lastPage: 1,
        ODLastVisited: undefined,
        id: userId,
    };
    if (OPExpSessionData !== undefined && OPExpSessionData !== null) {
        OPExpSessionData = JSON.parse(OPExpSessionData);
    }
    else {
        OPExpSessionData = defaultSessionData;
    }
    if ((OPExpSessionData === null || OPExpSessionData === void 0 ? void 0 : OPExpSessionData.id) !== userId) {
        OPExpSessionData = defaultSessionData;
        (_b = getWindow()) === null || _b === void 0 ? void 0 : _b.sessionStorage.removeItem('purchaseHistoryPage');
    }
    if ((OPExpSessionData === null || OPExpSessionData === void 0 ? void 0 : OPExpSessionData.ODLastVisited) !== undefined) {
        var dateNow = new Date();
        var dateDiff = (dateNow.getTime() -
            ((_e = (_d = new Date((_c = OPExpSessionData === null || OPExpSessionData === void 0 ? void 0 : OPExpSessionData.ODLastVisited) !== null && _c !== void 0 ? _c : '')) === null || _d === void 0 ? void 0 : _d.getTime()) !== null && _e !== void 0 ? _e : 0)) /
            1000;
        dateDiff /= 60;
        dateDiff = Math.abs(Math.round(dateDiff));
        if (dateDiff > 3) {
            // Reset variable if last visited date is more than 10 minutes ago
            OPExpSessionData = defaultSessionData;
            (_f = getWindow()) === null || _f === void 0 ? void 0 : _f.sessionStorage.removeItem('purchaseHistoryPage');
        }
    }
    return OPExpSessionData;
};
export var retrieveTrackingNumber = function (shipments) {
    var _a, _b, _c;
    var trackingNumber = (_a = shipments === null || shipments === void 0 ? void 0 : shipments.find(function (type) { return (type === null || type === void 0 ? void 0 : type.trackingType) === 'LastMile'; })) === null || _a === void 0 ? void 0 : _a.trackingNumber;
    if (!trackingNumber && ((_b = shipments === null || shipments === void 0 ? void 0 : shipments[0]) === null || _b === void 0 ? void 0 : _b.trackingNumber)) {
        return (_c = shipments === null || shipments === void 0 ? void 0 : shipments[0]) === null || _c === void 0 ? void 0 : _c.trackingNumber;
    }
    return trackingNumber;
};
export var normalize = function (value) {
    return (value || '').trim().toLowerCase().replace(/\s+/g, ' ');
}; // Normalize: trims, converts to lowercase, and replaces multiple spaces with a single space
